module.exports = __webpack_public_path__ + "static/media/JanFeb 12 (288).86902f0e.JPG";